// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oa-1";
export var messageSideRight = "_oa-2";
export var orderLookupBubbleContainer = "_oa-0";
export var submitButton = "_oa-3";